// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Page container */
.hub-container {
  min-height: 95vh;
  padding: 10px;
  background: linear-gradient(135deg, #ddddd862, #1e303b);
  color: white;
  font-family: Arial, sans-serif;
}

/* Title */
.hub-title {
  font-size: 40px;
  margin-bottom: 8px;
}

.hub-subtitle {
  opacity: 0.7;
  margin-bottom: 30px;
}

/* Grid layout */
.hub-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 20px;
}

/* Game card */
.hub-card {
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 16px;
  padding: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  box-shadow: 0 10px 30px rgba(0,0,0,0.3);
}

/* Hover effect */
.hub-card:hover {
  transform: translateY(-8px) scale(1.03);
  background: rgba(255, 255, 255, 0.12);
}

/* Icon */
.hub-icon {
  font-size: 40px;
  margin-bottom: 10px;
}

/* Button */
.hub-btn {
  margin-top: 12px;
  padding: 8px 14px;
  border: none;
  border-radius: 8px;
  background: #4f46e5;
  color: white;
  cursor: pointer;
  transition: 0.2s;
}

.hub-btn:hover {
  background: #6366f1;
}

/* Proverb-gate CTA */
.hub-unlock-cta {
  display: inline-block;
  margin-bottom: 24px;
  padding: 12px 20px;
  border: none;
  border-radius: 10px;
  background: #0f766e;
  color: #fff;
  font-weight: 700;
  font-size: 15px;
  cursor: pointer;
}

.hub-unlock-cta:hover {
  background: #0d635c;
}

/* Locked game slots */
.hub-slot {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.hub-slot-locked {
  opacity: 0.65;
}

.hub-slot-locked .mini-card {
  cursor: pointer;
}

.hub-lock-note {
  margin-top: 6px;
  font-size: 12px;
  opacity: 0.8;
}
`, "",{"version":3,"sources":["webpack://./src/features/Games/GamesHub/gameshub.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,aAAa;EACb,uDAAuD;EACvD,YAAY;EACZ,8BAA8B;AAChC;;AAEA,UAAU;AACV;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA,cAAc;AACd;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA,iBAAiB;AACjB;EACE,uCAAuC;EACvC,qCAAqC;AACvC;;AAEA,SAAS;AACT;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,YAAY;AACd","sourcesContent":["/* Page container */\n.hub-container {\n  min-height: 95vh;\n  padding: 10px;\n  background: linear-gradient(135deg, #ddddd862, #1e303b);\n  color: white;\n  font-family: Arial, sans-serif;\n}\n\n/* Title */\n.hub-title {\n  font-size: 40px;\n  margin-bottom: 8px;\n}\n\n.hub-subtitle {\n  opacity: 0.7;\n  margin-bottom: 30px;\n}\n\n/* Grid layout */\n.hub-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 20px;\n}\n\n/* Game card */\n.hub-card {\n  background: rgba(255, 255, 255, 0.08);\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  border-radius: 16px;\n  padding: 20px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  backdrop-filter: blur(10px);\n  box-shadow: 0 10px 30px rgba(0,0,0,0.3);\n}\n\n/* Hover effect */\n.hub-card:hover {\n  transform: translateY(-8px) scale(1.03);\n  background: rgba(255, 255, 255, 0.12);\n}\n\n/* Icon */\n.hub-icon {\n  font-size: 40px;\n  margin-bottom: 10px;\n}\n\n/* Button */\n.hub-btn {\n  margin-top: 12px;\n  padding: 8px 14px;\n  border: none;\n  border-radius: 8px;\n  background: #4f46e5;\n  color: white;\n  cursor: pointer;\n  transition: 0.2s;\n}\n\n.hub-btn:hover {\n  background: #6366f1;\n}\n\n/* Proverb-gate CTA */\n.hub-unlock-cta {\n  display: inline-block;\n  margin-bottom: 24px;\n  padding: 12px 20px;\n  border: none;\n  border-radius: 10px;\n  background: #0f766e;\n  color: #fff;\n  font-weight: 700;\n  font-size: 15px;\n  cursor: pointer;\n}\n\n.hub-unlock-cta:hover {\n  background: #0d635c;\n}\n\n/* Locked game slots */\n.hub-slot {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.hub-slot-locked {\n  opacity: 0.65;\n}\n\n.hub-slot-locked .mini-card {\n  cursor: pointer;\n}\n\n.hub-lock-note {\n  margin-top: 6px;\n  font-size: 12px;\n  opacity: 0.8;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
